import React from 'react';
import { Form, FormGroup, Forms, Label } from './HistoricAccounting.styles';
import "bootstrap/dist/css/bootstrap.min.css";
import { useState, useEffect, useRef } from 'react';
import apis, { getOvertimeByContractId } from '../../api';
import ConfBar from '../ConfBar/ConfBar';
import { Button } from 'primereact/button';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { FilterMatchMode, FilterOperator } from 'primereact/api';
import { InputText } from 'primereact/inputtext';
import { Dropdown } from 'primereact/dropdown';
import { Toast } from 'primereact/toast';
import Video from '../Video/Video';
import useWindowDimensions from '../hooks/useDimensions';
import './HistoricAccounting.css';
import '../../DataTableDemo.css';
import { IconField } from 'primereact/iconfield';
import { InputIcon } from 'primereact/inputicon';
import { excelExport } from '../../services/excelExport.service';
import { set } from 'lodash';

/* =============================================================================
Remuner software (c)
Vibe Consulting.
Componente : Overtime
Description : Creación de horas extras de un empleado.
Date Autor Modification
================================================================================
26/10/2021 Santiago Coca Rojas Creación – Se implementa la tabla desde cero.
================================================================================ */


export default function HistoricPayroll() {

  const [listaContrato, setListaContrato] = useState([]);
  const [listaConcepto, setListaConcepto] = useState([]);
  const [listaCalendario, setListaCalendario] = useState([]);

  const [calendario, setCalendario] = useState("");
  const [contrato, setContrato] = useState("");
  const [concepto, setConcepto] = useState("");
  const [ano, setAno] = useState("");
  const [mes, setMes] = useState("");
  const [rowId, setRowId] = useState(0);
  const headers = {
    authorization: localStorage.getItem('token')
  }
  const [rowData, setRowData] = useState([]);
  const [rows, setRows] = useState([]);
  const [first2, setFirst2] = useState(0);
  const [rows2, setRows2] = useState(10);
  const [selectedRows, setSelectedRows] = useState(null);
  const [filters1, setFilters1] = useState(null);
  const [globalFilterValue1, setGlobalFilterValue1] = useState('');
  const [loadingConsulta, setLoadingConsulta] = useState(false);
  const [loading2, setLoading2] = useState(false);
  const [consultado, setConsultado] = useState(false);
  const toast = useRef(null);
  const { width } = useWindowDimensions()

  useEffect(() => {

    const getLists = async () => {
      await apis.getValueListHistoricAccounting(localStorage.getItem("entity"), localStorage.getItem("client"), headers).then(res => {
        let conceptos = res.data["DETAIL"][0]["DETAIL"]
        let calendarios = res.data["DETAIL"][1]["DETAIL"]
        let contratos = res.data["DETAIL"][2]["DETAIL"]
        setListaContrato(contratos);
        setListaCalendario(calendarios);
        setListaConcepto(conceptos)
      })
    }
    getLists()
  }, [rowId]);

  const onCustomPage2 = (event) => {
    setFirst2(event.first);
    setRows2(event.rows);
  }

  const template2 = {
    layout: 'RowsPerPageDropdown CurrentPageReport PrevPageLink NextPageLink',
    'RowsPerPageDropdown': (options) => {
      const dropdownOptions = [
        { label: 5, value: 5 },
        { label: 10, value: 10 },
        { label: 20, value: 20 }
      ];

      return (
        <React.Fragment>
          <span className="mx-1" style={{ color: 'var(--text-color)', userSelect: 'none' }}>Elementos por página: </span>
          <Dropdown className="sel" value={options.value} options={dropdownOptions} onChange={options.onChange} />
        </React.Fragment>
      );
    },
    'CurrentPageReport': (options) => {
      return (
        <span style={{ color: 'var(--text-color)', userSelect: 'none', width: '120px', textAlign: 'center' }}>
          {options.first} - {options.last} of {options.totalRecords}
        </span>
      )
    }
  };


  const renderHeader1 = () => {
    return (
      <div className="b">
        <div className="b2">
          <Button type="button" icon="pi pi-file-excel" disabled={!consultado} label="Exportar" loading={loading2} onClick={() => { setLoading2(true); exportExcel() }} className="p-button-success mr-2" data-pr-tooltip="XLS" />
          <Button type="button" icon="pi pi-filter-slash" label="Limpiar filtros" className="p-button-outlined p-button-sm" onClick={clearFilter1} />
        </div>
        <IconField iconPosition="left">
          <InputIcon className="pi pi-search"> </InputIcon>
          <InputText className="p-inputtext-sm" value={globalFilterValue1} onChange={onGlobalFilterChange1} placeholder="Palabra clave"
            style={{
              width: "100%"
            }}
          />
        </IconField>
      </div>
    )
  }

  const onGlobalFilterChange1 = (e) => {
    const value = e.target.value;
    let _filters1 = {
      'global': { value: null, matchMode: FilterMatchMode.CONTAINS }
    };
    _filters1['global'].value = value;

    setFilters1(_filters1);
    setGlobalFilterValue1(value);
  }

  const clearFilter1 = () => {
    initFilters1();
  }

  const initFilters1 = () => {
    setFilters1({
      'global': { value: null, matchMode: FilterMatchMode.CONTAINS },
      'Identificación': { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] },
      'Nombre_tercero': { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] },
      'Id_tercero': { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] },
      'Calendario': { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] },
      'Calendario_contable': { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] },
      'Cuenta_1': { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] },
      'Cuenta_2': { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] },
      'Concepto': { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] },
      'Nombre_concepto': { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] },
      'Contrato': { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] },
      'Centro_de_costos': { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] },
      'Código_centro_de_costos': { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] },
      'Mes': { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] },
      'Año': { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] },
      'Naturaleza': { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] },
      'Porcentaje_APP': { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] },
      'Porcentaje_Dis': { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] },
      'Estado': { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] },
      'Valor': { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] },
      'Comprobante': { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] }
    });
    setGlobalFilterValue1('');
  }

  const header1 = renderHeader1();

  const matchModes = [
    { label: 'COMIENZA CON', value: FilterMatchMode.STARTS_WITH },
    { label: 'CONTIENE', value: FilterMatchMode.CONTAINS },
    { label: 'NO CONTIENE', value: FilterMatchMode.NOT_CONTAINS },
    { label: 'TERMINA CON', value: FilterMatchMode.ENDS_WITH },
    { label: 'IGUAL A', value: FilterMatchMode.EQUALS },
    { label: 'DIFERENTE A', value: FilterMatchMode.NOT_EQUALS }
  ];

  function handleSubmit(event) {
    event.preventDefault();
  }


  async function setTabla() {

    setLoadingConsulta(true)
    const _cliente = localStorage.getItem('client')
    const _entity = localStorage.getItem('entity')
    const _ano = ano
    const _mes = mes
    let _calendario = ""
    let _contrato = ""
    let _concepto = ""

    if (calendario !== "" && calendario !== undefined) {
      _calendario = calendario.CODE
    }
    if (contrato !== "" && contrato !== undefined) {
      _contrato = contrato.CODE
    }
    if (concepto !== "" && concepto !== undefined) {
      _concepto = concepto.CODE
    }

    const payroll = {
      CLIENT: _cliente,
      ENTITY: _entity,
      CALENDAR: _calendario,
      CONTRACT: _contrato,
      CONCEPT: _concepto,
      YEAR: _ano,
      MONTH: _mes
    }

    try {
      await apis.postHistoricAccounting(payroll, headers).then(res => {
        setLoadingConsulta(false)
        if (res.data["AUX_ACCOUNT"].length > 0) {
          let data = res.data["AUX_ACCOUNT"]
          let newRows = []
          data.forEach(d => {
            newRows.push({
              "Identificación": d.NUMBER_ID,
              "Nombre_tercero": d.THIRD_NAME,
              "Id_tercero": d.THIRD_ID,
              "Calendario": d.CALENDAR,
              "Calendario_contable": d.CALENDAR_ACCOUNT,
              "Cuenta_1": d.ACCOUNT_1,
              "Cuenta_2": d.ACCOUNT_2,
              "Concepto": d.CONCEPT,
              "Nombre_concepto": d.CONCEPT_NAME,
              "Contrato": d.CONTRACT,
              "Centro_de_costos": d.COST_CENTER,
              "Código_centro_de_costos": d.COST_CENTER_CODE,
              "Mes": d.MONTH,
              "Año": d.YEAR,
              "Naturaleza": d.NATURE,
              "Porcentaje_APP": d.PERCENT_APP,
              "Porcentaje_Dis": d.PERCENT_DIS,
              "Estado": d.STATE,
              "Valor": d.VALUE,
              "Comprobante": d.VOUCHER,
            })
          })
          setRows(newRows)
          setRowData(newRows)
          setConsultado(true)
          toast.current.show({ severity: 'success', summary: 'Éxito', detail: 'Consulta exitosa' });
        }
        else {
          setRows([])
          setRowData([])
          toast.current.show({ severity: 'warn', summary: 'Aviso', detail: 'Consulta sin resultados' });
        }
      })
    }
    catch (err) {
      setLoadingConsulta(false)
      toast.current.show({ severity: 'warn', summary: 'Aviso', detail: err.response.data.message, sticky: true });
    }
  }

  const exportExcel = () => {
    excelExport(rows, 'ConsultaContabilidad');
    setLoading2(true);
  }

  return (

    <div>
      <div className="surface-100	 px-4 py-5 md:px-6 lg:px-8">
        <Toast ref={toast} />
        <div className="flex flex-row align-items-center justify-content-center mb-3 font-bold text-4xl mt-2">
          <span className="text-900">Consulta Contabilidad</span>
          <Video header="Instructivo consultas" url={localStorage.getItem('HISTORICACCOUNTING_VIDEO')} />
        </div>
        <div style={{ marginBottom: "2rem" }}>
          <span style={{ fontSize: "0.8rem" }}>Campos obligatorios (*)</span>
        </div>
        <Form onSubmit={handleSubmit}>
          <Forms>
            <div className="inputs flex flex-row justify-content-between align-items-end">
              <div className="inputs flex flex-row">
                <FormGroup className="flex flex-column">
                  <Label htmlFor="label">Calendario</Label>
                  <Dropdown value={calendario}
                    filter showClear filterBy="NAME"
                    disabled={ano && mes || ano || mes}
                    style={{ width: "10rem" }}
                    options={listaCalendario} placeholder={"Seleccione un calendario"}
                    onChange={(e) => setCalendario(e.value)}
                    optionLabel='NAME'
                  />
                </FormGroup >
                &nbsp;
                <FormGroup className="flex flex-column">
                  <Label htmlFor="label">Contrato</Label>
                  <Dropdown value={contrato}
                    filter showClear filterBy="NAME"
                    options={listaContrato}
                    style={{ width: "10rem" }}
                    onChange={(e) => setContrato(e.value)}
                    placeholder={"Seleccione un empleado"} optionLabel='NAME'
                  />
                </FormGroup>
                &nbsp;
                <FormGroup className="flex flex-column">
                  <Label htmlFor="label">Concepto</Label>
                  <Dropdown value={concepto}
                    filter showClear filterBy="NAME"
                    options={listaConcepto}
                    style={{ width: "10rem" }}
                    onChange={(e) => setConcepto(e.value)}
                    placeholder={"Seleccione un concepto"} optionLabel='NAME'
                  />
                </FormGroup>
                &nbsp;
                <FormGroup className="flex flex-column">
                  {calendario ?
                    <Label htmlFor="label">Año</Label> :
                    <Label htmlFor="label">Año*</Label>}
                  <InputText
                    id="label7"
                    type="text"
                    maxLength={4}
                    disabled={calendario}
                    style={{ width: "5rem" }}
                    value={ano}
                    onChange={(e) => setAno(e.target.value)}
                  />
                </FormGroup>
                &nbsp;
                <FormGroup className="flex flex-column">
                  {calendario ?
                    <Label htmlFor="label">Mes</Label> :
                    <Label htmlFor="label">Mes*</Label>}
                  <InputText
                    id="label7"
                    type="text"
                    maxLength={2}
                    disabled={calendario}
                    style={{ width: "4rem" }}
                    value={mes}
                    onChange={(e) => setMes(e.target.value)}
                  />
                </FormGroup>
              </div>
              <Button className="h-3rem mt-2" label="Consultar" icon="pi pi-search" onClick={() => setTabla()} loading={loadingConsulta} />
            </div>
          </Forms>
        </Form>
        <div className="card mt-4">
          <DataTable className="text-xs" value={rows} paginator paginatorTemplate={template2} first={first2} rows={rows2} onPage={onCustomPage2}
            selection={selectedRows} onSelectionChange={(e) => setSelectedRows(e.value)} dataKey="ID"
            size="small" filters={filters1} filterDisplay="menu"
            globalFilterFields={['Identificación', 'Nombre_tercero', 'Id_tercero', 'Calendario', 'Calendario_contable', 'Cuenta_1', 'Cuenta_2', 'Concepto', 'Nombre_concepto',
              'Contrato', 'Centro_de_costos', 'Código_centro_de_costos', 'Mes', 'Año', 'Naturaleza', 'Porcentaje_APP', 'Porcentaje_Dis', 'Estado', 'Valor', 'Comprobante']}
            header={header1} >
            <Column selectionMode="single" headerStyle={{ width: '3em' }}></Column>
            <Column field="Identificación" header="Identificación" showFilterOperator={false} filterMatchModeOptions={matchModes} filter filterPlaceholder="Buscar por Identificación" sortable></Column>
            <Column field="Nombre_tercero" header="Nombre Tercero" showFilterOperator={false} filterMatchModeOptions={matchModes} filter filterPlaceholder="Buscar por Nombre" sortable></Column>
            <Column field="Id_tercero" header="Id Tercero" showFilterOperator={false} filterMatchModeOptions={matchModes} filter filterPlaceholder="Buscar por Calendario" sortable></Column>
            <Column field="Calendario" header="Calendario" showFilterOperator={false} filterMatchModeOptions={matchModes} filter filterPlaceholder="Buscar por Concepto" sortable></Column>
            <Column field="Calendario_contable" header="Calendario Contable" showFilterOperator={false} filterMatchModeOptions={matchModes} filter filterPlaceholder="Buscar por Valor" sortable></Column>
            <Column field="Cuenta_1" header="Cuenta 1" showFilterOperator={false} filterMatchModeOptions={matchModes} filter filterPlaceholder="Buscar por Nombre concepto" sortable></Column>
            <Column field="Cuenta_2" header="Cuenta 2" showFilterOperator={false} filterMatchModeOptions={matchModes} filter filterPlaceholder="Buscar por Tipo concepto" sortable></Column>
            <Column field="Concepto" header="Concepto" showFilterOperator={false} filterMatchModeOptions={matchModes} filter filterPlaceholder="Buscar por Consolidado" sortable></Column>
            <Column field="Nombre_concepto" header="Nombre Concepto" showFilterOperator={false} filterMatchModeOptions={matchModes} filter filterPlaceholder="Buscar por Unidades consolidado" sortable></Column>
            <Column field="Contrato" header="Contrato" showFilterOperator={false} filterMatchModeOptions={matchModes} filter filterPlaceholder="Buscar por Unidades consolidado" sortable></Column>
            <Column field="Centro_de_costos" header="Centro de Costos" showFilterOperator={false} filterMatchModeOptions={matchModes} filter filterPlaceholder="Buscar por Unidades consolidado" sortable></Column>
            <Column field="Código_centro_de_costos" header="Código Centro de Costos" showFilterOperator={false} filterMatchModeOptions={matchModes} filter filterPlaceholder="Buscar por Unidades consolidado" sortable></Column>
            <Column field="Mes" header="Mes" showFilterOperator={false} filterMatchModeOptions={matchModes} filter filterPlaceholder="Buscar por Unidades consolidado" sortable></Column>
            <Column field="Año" header="Año" showFilterOperator={false} filterMatchModeOptions={matchModes} filter filterPlaceholder="Buscar por Unidades consolidado" sortable></Column>
            <Column field="Naturaleza" header="Naturaleza" showFilterOperator={false} filterMatchModeOptions={matchModes} filter filterPlaceholder="Buscar por Unidades consolidado" sortable></Column>
            <Column field="Porcentaje_APP" header="Porcentaje APP" showFilterOperator={false} filterMatchModeOptions={matchModes} filter filterPlaceholder="Buscar por Unidades consolidado" sortable></Column>
            <Column field="Porcentaje_Dis" header="Porcentaje Dis" showFilterOperator={false} filterMatchModeOptions={matchModes} filter filterPlaceholder="Buscar por Unidades consolidado" sortable></Column>
            <Column field="Estado" header="Estado" showFilterOperator={false} filterMatchModeOptions={matchModes} filter filterPlaceholder="Buscar por Unidades consolidado" sortable></Column>
            <Column field="Valor" header="Valor" showFilterOperator={false} filterMatchModeOptions={matchModes} filter filterPlaceholder="Buscar por Unidades consolidado" sortable></Column>
            <Column field="Comprobante" header="Comprobante" showFilterOperator={false} filterMatchModeOptions={matchModes} filter filterPlaceholder="Buscar por Unidades consolidado" sortable></Column>
          </DataTable>
        </div>
      </div>
    </div>
  );
}